module.exports = "/_next/static/images/mobilelending-duotone-4ac3342b41e1d20500acd1eb1c65c2ab.svg";